import styled, { StyledProps } from 'styled-components/macro';

export type SearchInputProps = StyledProps<{}>;

export const SearchInput = styled.div<SearchInputProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: '#ff0000';

  svg {
    color: ${(props) => props.theme.colors.gray};
  }

  input {
    height: 30px;
    width: 100%;
    background: #ffffff;
    border: 1px solid ${(props) => props.theme.colors.gray};
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0 27px 0 7px;
    color: #1d1e25;
    font-size: 14px;
    flex: 1;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.gray};
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

export const SearchInputIconContainer = styled.div`
  display: flex;
  position: absolute;
  right: 7px;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;

  .clear {
    width: 40px;
    height: 40px;
  }
`;

export const SearchInputButton = styled.div<{
  showHandCursor?: boolean;
}>`
  width: 20px;
  height: 40px;
  cursor: ${(props) => (props.showHandCursor ? 'pointer' : 'auto')};
  display: flex;
  justify-content: center;
  align-items: center;
`;
SearchInputButton.defaultProps = { showHandCursor: false };
